export const formatTicketDuration = (duration: string): string => {
    const mins = +duration;

    if (mins < 60) {
        if (!mins) {
            return '';
        }

        return `${mins} mins`;
    }

    const extraMins = mins % 60;

    if (extraMins) {
        return `${(mins / 60).toFixed(1)} hrs`;
    } else {
        const hours = Math.floor(mins / 60);

        return `${hours} hr${hours > 1 ? 's' : ''}`;
    }
};
